import { render } from "./UserBatchCreate.vue?vue&type=template&id=2080fc51&scoped=true"
import script from "./UserBatchCreate.vue?vue&type=script&lang=js"
export * from "./UserBatchCreate.vue?vue&type=script&lang=js"

import "./UserBatchCreate.vue?vue&type=style&index=0&id=2080fc51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2080fc51"]])

export default __exports__